import React, { useState} from 'react';
import Photo from '../../assets/profile-icon.png'
import './Profile.css';
import ChangePasswordModal from '../../components/ChangePasswordModal/Modal.js';
import EditProfileModal from './EditProfileModal.js';
import { useCookies } from 'react-cookie';

const Profile = () => {
    const [cookies, setCookie] = useCookies();
    const fName = cookies.firstName;
    const lName = cookies.lastName;
    const pNumber = cookies.phoneNumber;
    const mNumber = cookies.mobileNumber;
    const pPicture = cookies.profilePictureUrl;

    const [userData, setUserData] = useState({
        firstName: fName,
        lastName: lName,
        phoneNumber: pNumber,
        mobile: mNumber,
      });

    const [profilePictureUrl, setProfilePictureUrl] = useState(pPicture);
    
    const [passwordModalShow, setPasswordModalShow] = React.useState(false);
    const [editModalShow, setEditModalShow] = React.useState(false);


    const handlePasswordClose = () => {
        setPasswordModalShow(false);
    };

    const handleEditClose = () => {
        setEditModalShow(false);
    };

    const handleImageError = () => {
        setProfilePictureUrl(Photo);
    }; 

    const handleChangePicture = (e) => {

        const token = cookies.token;

        var myHeaders = new Headers();
        myHeaders.append("Valid-token", token);

        var formdata = new FormData();
        formdata.append("", e.target.files[0], "new profile picture file.jpg");

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        };

        fetch("https://services.solucore.com/solutrak/api/accounts/uploadProfilePicture", requestOptions)
        .then(response => response.text())
        .then(result => {
            // Check the result and handle accordingly
            const data = JSON.parse(result);
            const status = data.IsSuccess;
          if (status) {
              window.alert("Your profile picture has been succesfully updated to: " + data.Data.newName);
              setCookie('profilePictureUrl', data.Data.url);
              window.location.reload();
          } else {
              window.alert("Status: " + data.IsSuccess + "\n" + data.Message )
          }
        })
        .catch(error => window.alert('error', error));
        };

    const profileFields = [
        { label: 'First Name', value: userData.firstName, icon: '👤' },
        { label: 'Last Name', value: userData.lastName, icon: '👤' },
        { label: 'Phone Number', value: userData.phoneNumber, icon: '📞' },
        { label: 'Mobile', value: userData.mobile, icon: '📱' },
    ];

    return(
        <div className="bg-[#0F172A] p-6 overflow-y-auto h-full w-full flex flex-col">
          {/* Header */}
          <h1 className="text-2xl font-bold text-white mb-6">My Profile</h1>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 flex-1">
            {/* Profile Picture Card */}
            <div className="bg-slate-800/60 border border-slate-700/50 rounded-xl p-8 flex flex-col items-center justify-center">
              <div className="relative mb-6">
                <img
                  src={profilePictureUrl}
                  alt="Profile"
                  className="w-32 h-32 rounded-full object-cover border-4 border-cyan-500/30 shadow-lg shadow-cyan-500/10"
                  onError={handleImageError}
                />
                <label
                  htmlFor="profile-upload"
                  className="absolute bottom-1 right-1 w-9 h-9 bg-cyan-500 hover:bg-cyan-400 rounded-full flex items-center justify-center cursor-pointer transition-colors shadow-lg"
                  title="Change picture"
                >
                  <span className="text-white text-sm">📷</span>
                </label>
                <input
                  id="profile-upload"
                  type="file"
                  className="hidden"
                  accept="image/*"
                  onChange={handleChangePicture}
                />
              </div>
              <h2 className="text-lg font-semibold text-white">
                {userData.firstName} {userData.lastName}
              </h2>
              <p className="text-sm text-slate-400 mt-1">Elevator Technician</p>
            </div>

            {/* Profile Details Card */}
            <div className="lg:col-span-2 bg-slate-800/60 border border-slate-700/50 rounded-xl p-6">
              <div className="flex items-center justify-between mb-6 pb-4 border-b border-slate-700/50">
                <h2 className="text-lg font-bold text-white">Profile Details</h2>
              </div>

              <div className="space-y-5">
                {profileFields.map((field, idx) => (
                  <div key={idx} className="flex items-center gap-4">
                    <span className="text-xl w-8 text-center">{field.icon}</span>
                    <div className="flex-1">
                      <p className="text-xs font-semibold uppercase tracking-wider text-slate-400 mb-1">{field.label}</p>
                      <p className="text-base text-white font-medium">{field.value || '—'}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Action Buttons */}
              <div className="flex gap-3 mt-8 pt-6 border-t border-slate-700/50">
                <button
                  onClick={() => setEditModalShow(true)}
                  className="px-5 py-2.5 text-sm font-medium text-white bg-gradient-to-r from-cyan-500 to-blue-500 rounded-lg hover:from-cyan-400 hover:to-blue-400 transition-all shadow-lg shadow-cyan-500/20"
                >
                  Edit Profile
                </button>
                <button
                  onClick={() => setPasswordModalShow(true)}
                  className="px-5 py-2.5 text-sm font-medium text-slate-300 bg-slate-700/60 border border-slate-600/50 rounded-lg hover:bg-slate-600/60 hover:text-white transition-colors"
                >
                  Change Password
                </button>
              </div>
            </div>
          </div>

          <ChangePasswordModal show={passwordModalShow} onHide={handlePasswordClose} />
          <EditProfileModal show={editModalShow} onHide={handleEditClose}/>
        </div>
        );
};

export default Profile;